import StoreCouponsPage from 'components/pages/Store';

import getServerDateProps from 'lib/date/getServerDateProps';
import { toStoreCouponsLink } from 'lib/links';
import { resolvify } from 'lib/promises';

import { getActiveAdsByStore, getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getCouponFeaturedStoresList } from 'services/coupon';
import { getLandingsList } from 'services/landing';
import {
  getStoreCouponsList,
  getStoreInfo,
  getStoreOffersList,
  getStoresList,
} from 'services/store';

import APP from 'constants/app';
import COUPONS from 'constants/coupons';
import LINKS from 'constants/links';
import STORES from 'constants/store';

const StoreCoupons = (props) => (
  <StoreCouponsPage
    {...props}
    gaEventCategory={COUPONS.COUPONS_STORE_GA_EVENT_CATEGORY}
    isExclusivelyCoupon
  />
);

export const getServerSideProps = async ({ params: { storeSlug }, req }) => {
  /**
   * This resolves the retroactive of some 404 errors when some slugs going
   * with unwanted whitespaces.
   */
  if (!storeSlug || storeSlug.trim() !== storeSlug) {
    return {
      redirect: { destination: toStoreCouponsLink(storeSlug), permanent: true },
    };
  }

  try {
    const [
      store,
      serverOffers,
      serverCoupons,
      featuredStores,
      storeAd,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getStoreInfo({ storeSlug }),
      getStoreOffersList({ limit: STORES.STORE_OFFERS_PAGE_SIZE, storeSlug }),
      // SSR reads auth cookie to fetch the exact coupon count per user
      // type (40 logged-out, 20 logged-in). No client-side truncation
      // needed — avoids content flash on hydration.
      // Note: is_user_logged is a UX hint set by the client, not a
      // verified auth token. Spoofing it yields fewer coupons (20 vs 40),
      // so there is no privilege escalation. Do not gate sensitive data
      // or actions on this cookie alone.
      getStoreCouponsList({
        storeSlug,
        limit:
          req.cookies?.is_user_logged === 'true'
            ? COUPONS.COUPON_LIMIT_LOGGED_IN
            : COUPONS.COUPON_LIMIT_LOGGED_OUT,
      }),
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      {
        fn: getActiveAdsByStore({ storeSlug }),
        fallback: getActiveAdsByStore.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    /**
     * As the url for the Promobit store is different `LINKS.PROMOBIT_COUPONS`
     * and not /cupons/loja/promobit we do this redirect to keep it consistent.
     */
    if (store.storeId === STORES.PROMOBIT_STORE_ID) {
      return {
        redirect: { destination: LINKS.PROMOBIT_COUPONS, permanent: true },
      };
    }

    return {
      props: {
        featuredStores,
        serverCoupons,
        ...getServerDateProps(),
        serverOffers,
        store,
        storeAd,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default StoreCoupons;
